import React from "react";
import { Button, Typography, withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import style from "style";
import BannerHeaderText from "./BannerHeaderText";

const BannerDetailsContainer = ({ classes, trackBannerClick, ...banner }) => {
  return (
    <div>
      <BannerHeaderText {...banner} />
      {banner.copy !== "" && (
        <Typography
          variant="h5"
          style={{
            textAlign: "center",
            lineHeight: "1",
          }}
        >
          <span
            className={classes.smallerFont}
            dangerouslySetInnerHTML={{
              __html: banner.copy,
            }}
          />
        </Typography>
      )}
      <br />
      {banner.cta !== "" && (
        <div
          style={{
            textAlign: "center",
          }}
        >
          {banner.field_link_type === "External" ? (
            <Button
              href={banner.link}
              size="medium"
              variant="contained"
              color="secondary"
              onClick={trackBannerClick}
            >
              {banner.cta}
            </Button>
          ) : (
            <Button
              component={Link}
              to={banner.link}
              size="medium"
              variant="contained"
              onClick={trackBannerClick}
              color="secondary"
            >
              {banner.cta}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default withStyles(style)(BannerDetailsContainer);
